// @flow
import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest
} from 'redux-saga/effects'
import { requestStatusUpdate } from '../components/loadingIndicator/reducer'
import { rentPricesUpdate } from '../components/map/reducer'
import { json } from 'd3.promise'
import {
  watchActiveMunicipality,
  watchAnnotatedElement
} from 'components/popup/saga'
import config from 'config'
import analyticsWatcher from './analytics'

const apiEndpoint = config.apiEndpoint

/**
 * Root saga, triggers all other sagas
 */
export default function * rootSaga () {
  yield all([
    watchAll(),
    requestData(),
    watchSelector(),
    watchActiveMunicipality(),
    watchAnnotatedElement(),
    analyticsWatcher()
  ])
}

function * watchSelector () {
  yield takeLatest(
    action => /^SELECTOR\/FLATSIZE/.test(action.type),
    requestData
  )
}

function * requestData ({ payload } = { payload: 3 }) {
  let flatSize = payload
  yield put(requestStatusUpdate('loading'))
  try {
    let municipalityData = yield call(fetchRentPrices, flatSize)
    yield put(rentPricesUpdate(municipalityData))
    yield put(requestStatusUpdate('success'))
  } catch (err) {
    yield put(requestStatusUpdate('error'))
    console.log(err)
  }
}

function fetchRentPrices (flatSize) {
  return json(`${apiEndpoint}/${flatSize}.json`)
}

/**
 * Do something with every action that takes place. Like logging them.
 */
function * watchAll () {
  if (process.env.NODE_ENV === 'development') {
    yield takeEvery('*', log)
  }
}

function * log (action) {
  let state = yield select()
  console.log(action, state)
}
